/**
 * Uplifted WHOLE from `utils/checkoutConstants.ts` — the file exists in BOTH apps and the two
 * copies are token-identical (9 exports each, 0 web-only, 0 mobile-only, 0 differing bodies;
 * measured by symbol/body diff after whitespace normalisation). So everything lives here and
 * both variants are a bare `export * from "./shared"` (ledger rule 4: always all three files,
 * even at 100% identical).
 *
 * Pure data — no imports, nothing read at load time.
 */

/**
 * KEYS CONSTANTS
 */
export const FULL_PAYMENT_KEY = "fullPayment";
export const NC_KEY = "NC";
export const PARTIAL_PAYMENT_KEY = "partialPayment";
export const SPLIT_PAYMENT_KEY = "splitPayment";

/**
 * VALUES CONSTANTS
 */
export const FULL_PAYMENT = "Full Payment";
export const NON_CHARGEABLE = "Non chargeable";
export const PARTIAL_PAYMENT = "Partial Payment";
export const SPLIT_PAYMENT = "Split Payment";

/**
 * Stands in for what the deleted `selectedPaymentStore.selectedPayment` always was: an
 * empty object. That slice declared no reducers and was in no persist whitelist, so it
 * could never hold anything else — every read of it got this value, which is why removing
 * the slice was behaviour-neutral.
 *
 * It must stay `{}` and never `undefined`: the call sites do unguarded property access
 * (`selectedPayment.mode`), which yields `undefined` on an empty object but THROWS on
 * `undefined`.
 *
 * Temporary. The live payment selection is `checkoutContextState.selectedPayment`; these
 * call sites were never migrated to it, so each is a branch frozen on one outcome. When
 * they are repointed at the context, this constant and its uses disappear.
 */
export const SELECTED_PAYMENT_STORE_SELECTED_PAYMENT: Record<string, any> = {};
